export const ROUTES_EN = {
  HOME: 'Home',
  EXPERIENCE: 'Experience',
  SKILLS: 'Skills',
  PROJECTS: 'Projects',
  CONTACTS: 'Contacts',
};
